import script from "./PresenceUserDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./PresenceUserDialog.vue?vue&type=script&setup=true&lang=js"

import "./PresenceUserDialog.vue?vue&type=style&index=0&id=5ca3e485&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ca3e485"]])

export default __exports__